import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import styled from 'styled-components';

import { Section, Title } from '../shared';
import Video from './Video';

import { maxWidth } from '../../helpers/media-queries';

const Wrapper = styled.div `
    &:before, &:after {
        content: '';
        position: absolute;
        background-repeat: no-repeat;
        background-size: contain;
    }

    & .trailer-wrapper {
        background-color: #766657;
    }

    & .trailer-wrapper > h3 {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #403831;
        min-height: 75px;
    }

    & .trailer-wrapper > h3:after {
        transform: rotate(180deg);
    }

    & video {
        border: 5px solid black;
    }
`;

const styles = ({ palette, sizes }) => ({
    root: {
        overflow: 'hidden',
        '& h3': {
            textAlign: 'center',
            color: '#ffffff',
        },

        '& .wrapper': {        
            position: 'relative',
            borderStyle: 'solid',
            borderWidth: '32px 32px 40px 32px',
            borderImage: 'url(./static/images/trailer/border.png) 110 139 137 137 round',

            [maxWidth.md]: {
                borderWidth: '22px 22px 30px 22px',
            },
    
        },

        '& .trailer-video-wrapper': {
            padding: `10px ${sizes.baseSize}px ${sizes.baseSize}px`,
            borderBottom: '10px solid #403831',

            [maxWidth.sm]: {
                padding: `${sizes.baseSize}px 0px`,
            },
        },

        '& img': {
            margin: 'auto',
            display: 'flex',

            [maxWidth.sm]: {
                width: '100%',
                height: 'auto',
            },
        },

        '& p': {
            color: '#FFFFFF',
            textAlign: 'center',
        }
    }
});

const mapper = (stores) => ({
    intl: stores.intl.dictionary,
})

class Trailer extends Component {
    render() {
        const { intl, classes } = this.props;
        return (
            <Section className={classes.root} id="seccion-trailer">
                <Wrapper className="wrapper">
                    <div className="trailer-wrapper">
                        <Title>{intl['LOCALE.VIDEO']}</Title>
                        <div className="trailer-video-wrapper">
                            <p>{intl['LOCALE.VIDEO.TEXT']}</p>
                            <Video />
                        </div>
                        <img
                            src="./static/images/trailer/tv-btn.png"
                            alt={intl['LOCALE.VIDEO.BTN']}
                            title={intl['LOCALE.VIDEO.BTN']} />
                    </div>
                </Wrapper>
            </Section>
        )
    }
}

export default inject(mapper)(
    withStyles(styles)(Trailer)
);